import { Component, Input, OnInit } from '@angular/core';
import { ID } from '../../../../models/ID';
import { Address } from "../../../../interface/address.inteface";
import { DocumentData } from "../../models/document-data.model";
import { ImageUtil } from "@qid/core";
import { CommonModule } from '@angular/common';
import { SexyModule } from '@qid/sexy';

@Component({
  selector: 'sid-view',
  templateUrl: './sid-view.component.html',
  styleUrls: ['./sid-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
  ],
})
export class SidViewComponent implements OnInit {

  @Input() id: ID = null
  @Input() documentData: DocumentData = null
  public sidKeys = {
    aadhaar: "ADHAR",
    pan: "PANCR",
    dl: 'dl'
  };

  constructor() {
  }

  ngOnInit() {
  }

  getStyledIdNumber(number: string) {
    if (number?.length % 4 != 0) {
      return number;
    }
    let joy = number.match(/.{1,4}/g);
    return joy.join(' ');
  }

  getAddressLine() {
    const address: Address = this.documentData?.address;
    let addressLine = '';
    if (address.house) {
      addressLine += address.house + ', ';
    }
    if (address.street) {
      addressLine += address.street + ', ';
    }
    if (address.dist) {
      addressLine += address.dist + ', ';
    }
    if (address.state) {
      addressLine += address.state + ', ';
    }
    if (address.zipCode) {
      addressLine += '- ' + address.zipCode;
    }
    return addressLine;
  }

  protected readonly ImageUtil = ImageUtil;
}
